import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { User } from "../../../../types/user";
import { eCustomUserCardDetailProps } from "./UserManagement";
import { Page } from "../../../../types/Page";
import { Loader } from "@progress/kendo-react-indicators";

interface UserListPaginatedProps{
    GetFilteredUsers:(profileName: string) => User[];
    CustomUserCardDetail:(userCardDetailProps: eCustomUserCardDetailProps) => JSX.Element;
    page:Page;
    sendRequest:() => Promise<void>;
    tabStripName:string;
    loading:boolean;
    error:string;
}

const UserListPaginated = React.memo<UserListPaginatedProps>((
    {GetFilteredUsers,CustomUserCardDetail,page,sendRequest,tabStripName,loading,error}
)=>{
    let users = GetFilteredUsers(tabStripName);
    return(
    loading ? (
            <div className="d-flex align-items-center justify-content-center m-t-30">
            <Loader type={"infinite-spinner"} />
        </div>
    ) : (
        <div className="cardBrand">
            <div className="cardListArea p-0 pl-3">
                <div id="scrollableDiv" style={{ height: '100%', overflow: 'auto', padding: '0 45px 0 15px' }}>
                    <InfiniteScroll
                        dataLength={users.length}
                        next={sendRequest}
                        hasMore={(!error && users.length > 0 && page.totalRecords!==undefined) && users.length<page.totalRecords}
                        loader={<div className="col-12 text-center"><Loader/></div>}
                        scrollableTarget="scrollableDiv"
                        className="row"
                    >
                    {users.map((user:User, index:number) => (
                        <CustomUserCardDetail user={user} key={user.id} index={index} />
                    ))}
                    </InfiniteScroll>
                </div>
                {(!loading && users.length===0) && (
                        <div className="text-center">
                            <span>No users available</span>
                        </div>
                    )}
                {error && (
                    <div className="text-center">
                        <span className="tx-red">Something went wrong. Please try again later.</span>
                    </div>
                )}
             </div>
         </div>
        )
    )
})

export default UserListPaginated;